module.exports = __webpack_public_path__ + "img/place.3e6ff4e5.png";